module.exports = __webpack_public_path__ + "static/media/Sign Up 1.a1b484ff.svg";